import { ChangeDetectionStrategy, Component, OnInit, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { faFire } from '@fortawesome/free-solid-svg-icons';
import { Title } from '@angular/platform-browser';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})

export class AssessmentsComponent implements OnInit {
  //icons
  faFire = faFire;

  //access
  user: any;

  tab = input.required<number>();
  tabIndex = 0;

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly userService: UserService,
    private readonly route: ActivatedRoute,
  ) {
    this.titleService.setTitle("BAER - Assessments")
  }

  ngOnInit(): void {
    if (this.tab()) {
      this.tabIndex = this.tab()
    }
    this.loadUser();

    this.route.fragment.subscribe((fragment) => {
      if (fragment == 'requests') {
        this.tabIndex = 1;
      }
    });
  }

  loadUser() {
    this.userService.getUserProfile().then(async (user) => {
      this.user = user;
    });
  }
}
